import React from "react";
const SvgMapLocalization = props => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <g fill="#1A1F24" fillRule="evenodd" clipRule="evenodd">
      <path d="M12 2.5a.5.5 0 01.5.5v1.516a7.501 7.501 0 016.983 6.984H21a.5.5 0 010 1h-1.517a7.501 7.501 0 01-6.983 6.984V21a.5.5 0 01-1 0v-1.516A7.501 7.501 0 014.516 12.5H3a.5.5 0 010-1h1.516A7.501 7.501 0 0111.5 4.516V3a.5.5 0 01.5-.5zm0 3a6.5 6.5 0 100 13 6.5 6.5 0 000-13z" />
      <path d="M14 12a2 2 0 11-3.999.001A2 2 0 0114 12z" />
    </g>
  </svg>
);
export default SvgMapLocalization;
